import { Action, createReducer, on } from '@ngrx/store';

import { IPaginationOptions } from '../interfaces';
import * as PaginationActions from './pagination.actions';

export const initialState: IPaginationOptions = {
  maxPages: 3,
  perPage: 10,
};

// tslint:disable-next-line: typedef
export function paginationReducer(existingState: IPaginationOptions, action: Action) {
  return createReducer(
    initialState,
    on(PaginationActions.setMaxPagesSuccess, (state, { maxPagesData }) => ({
      ...state,
      maxPages: maxPagesData
    })),
    on(PaginationActions.setPerPageSuccess, (state, { perPageData }) => ({
      ...state,
      perPage: perPageData,
    }))
  )(existingState, action);
}

export const maxPages = (state: IPaginationOptions) => state.maxPages;
export const perPage = (state: IPaginationOptions) => state.perPage;
